module.exports = __webpack_public_path__ + "img/person-1.5bf7a3b.webp";